import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { getIsModalOpen, useModalState } from "./../../ricos-modals/modal-service-provider";
import { DropdownButton } from "./../../toolbars-ui";
import { LayoutGridIcon } from "../assets/icons/LayoutGridIcon";
import { POLL_LAYOUT_DROPDOWN_MODAL_ID } from "../consts";
import { dropdownOptions } from "./poll-layout-dropdown";
const PollLayoutDropdownButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(POLL_LAYOUT_DROPDOWN_MODAL_ID));
  const [referenceElement, setReferenceElement] = useState(null);
  const selectedLayout = dropdownOptions[toolbarItem?.attributes.layout] || dropdownOptions.GRID;
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick: () => toolbarItem.commands?.click({ referenceElement }),
      setRef: setReferenceElement,
      Icon: selectedLayout?.icon || LayoutGridIcon,
      label: t(selectedLayout?.text || "Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid"),
      tooltip: t("Poll_PollSettings_Tab_Layout_TabName")
    }
  );
};
export {
  PollLayoutDropdownButton
};
//# sourceMappingURL=poll-layout-dropdown-button.js.map
